import { useEffect, useState } from 'react';

const readOnline = (): boolean =>
  typeof navigator === 'undefined' ? true : navigator.onLine;

export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(readOnline);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    setIsOnline(readOnline());

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
